import React, { useState, useEffect } from "react";
import logo from "../assets/images/hey-visuals-logo.png";
import { Link, useLocation } from "react-router-dom";
import AsideMenuItem from "./AsideMenuItem";

const Aside = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);

  useEffect(() => {
    if (["/captions", "/images", "/avatars", "/videos"].includes(location.pathname)) {
      setIsGenerateOpen(true); 
    }
  }, [location.pathname]); 

  const handleTabClick = (path) => {
    setActiveTab(path);
    if (["/captions", "/images", "/avatars", "/videos"].includes(path)) {
      setIsGenerateOpen(true); 
    } else {
      setIsGenerateOpen(false); 
    }
  };

  return (
    <div
      style={{ boxShadow: "0 .01rem 0.2rem rgba(0, 0, 0, .15)", width: "140px" , height:'100vh'}}
      id="kt_aside"
      className="aside overflow-visible pb-5 pt-5 pt-lg-0" >
      <div id="kt_aside_logo" className="aside-logo py-8">
        <Link to="/" className="d-flex align-items-center fw-normal">
          <img src={logo} alt="logo" className="w-100" />
        </Link>
      </div>

      <div id="kt_aside_menu" className="aside-menu flex-column-fluid">
        <div
          id="kt_aside_menu_wrapper"
          className="hover-scroll-overlay-y my-2 mb-lg-5 pe-lg-n1"
          style={{ height: "70.3vh" }}>
          <div
            id="kt_aside_menu"
            className="menu menu-column menu-title-gray-700 menu-arrow-gray-500 fw-semibold">
            {/* Home Tab */}
            <AsideMenuItem href="/"
              iconClass="ki-outline ki-home-2 fs-2x" title="Home" isActive={activeTab === "/"}
              onClick={() => handleTabClick("/")} />

            {/* Generate Section */}
            <AsideMenuItem
              toggleId="generate-collapseOne"
              iconClass="ki-outline ki-educare fs-2x"
              title="Generate"
              isActive={["/captions", "/images", "/avatars", "/videos"].includes(activeTab)}
              isOpen={isGenerateOpen} 
              onToggle={() => setIsGenerateOpen(!isGenerateOpen)}>
              <div style={{ backgroundColor: "#F8F8F8" }}>
              <Link
                  to="/videos"
                  className={`menu-link ${activeTab === "/videos" ? "active-tab text-primary" : ""}`}
                  onClick={() => handleTabClick("/videos")}
                  style={{ alignItems: "center" }}
                >
                  <i className="ki-outline ki-screen fs-1x p-2"></i> Videos
                </Link>
                <Link
                  to="/images"
                  className={`menu-link ${activeTab === "/images" ? "active-tab text-primary" : ""}`}
                  onClick={() => handleTabClick("/images")}
                  style={{ alignItems: "center" }}>
                  <i className="ki-outline ki-picture fs-1x p-2"></i> Images
                </Link>
                <Link
                  to="/avatars"
                  className={`menu-link ${activeTab === "/avatars" ? "active-tab text-primary" : ""}`}
                  onClick={() => handleTabClick("/avatars")}
                  style={{ alignItems: "center" }}
                >
                  <i className="ki-outline ki-user-tick fs-1x p-2"></i> Avatars
                </Link>
                <Link
                  to="/captions"
                  className={`menu-link ${activeTab === "/captions" ? "active-tab text-primary" : ""}`}
                  onClick={() => handleTabClick("/captions")}
                  style={{ alignItems: "center" }}>
                  <i className="ki-outline ki-instagram fs-1x p-2"></i> Captions
                </Link>
              </div>
            </AsideMenuItem>

            {/* Other Tabs */}
            <AsideMenuItem
              href="/history"
              iconClass="ki-outline ki-notification-status fs-2x"
              title="History"
              isActive={activeTab === "/history"}
              onClick={() => handleTabClick("/history")} />
            <AsideMenuItem
              href="/plans"
              iconClass="ki-outline ki-abstract-35 fs-2x"
              title="Plans"
              isActive={activeTab === "/plans"}
              onClick={() => handleTabClick("/plans")} />
            <AsideMenuItem
              href="/help"
              iconClass="ki-outline ki-briefcase fs-2x"
              title="Help"
              isActive={activeTab === "/help"}
              onClick={() => handleTabClick("/help")} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aside;
